const host = 'http://guan.xuanyue.zaihukeji.cn'
export {
  host
}